export interface ConvergenceBuckets {
  rework: number;
  review: number;
  ready: number;
  unscored: number;
}

// Thresholds match the rubric in CLAUDE.md:
//   <70% rework, 70-89% manual review, 90%+ ready to ship
// Null scores are counted separately (not yet scored).
export function bucketByConvergence(
  outcomes: readonly { convergenceScore: number | null }[]
): ConvergenceBuckets {
  const buckets: ConvergenceBuckets = { rework: 0, review: 0, ready: 0, unscored: 0 };
  for (const outcome of outcomes) {
    if (outcome.convergenceScore === null) {
      buckets.unscored += 1;
    } else if (outcome.convergenceScore >= 90) {
      buckets.ready += 1;
    } else if (outcome.convergenceScore >= 70) {
      buckets.review += 1;
    } else {
      buckets.rework += 1;
    }
  }
  return buckets;
}
